import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export const CONCESSIONS = [
  { id: 'chomedey_hyundai',    label: 'Chomedey Hyundai',    marque: 'Hyundai' },
  { id: 'hyundai_blainville',  label: 'Hyundai Blainville',  marque: 'Hyundai' },
  { id: 'honda_blainville',    label: 'Honda Blainville',    marque: 'Honda'   },
  { id: 'subaru_rive_nord',    label: 'Subaru Rive-Nord',    marque: 'Subaru'  },
  { id: 'lachute_subaru',      label: 'Lachute Subaru',      marque: 'Subaru'  },
  { id: 'subaru_ste_agathe',   label: 'Subaru Ste-Agathe',   marque: 'Subaru'  },
]

export const MARQUE_COLORS = {
  Hyundai: '#185FA5',
  Honda:   '#C8102E',
  Subaru:  '#3B6D11',
}

export const MOIS_FR = [
  '', 'Janvier','Février','Mars','Avril','Mai','Juin',
  'Juillet','Août','Septembre','Octobre','Novembre','Décembre'
]

export async function getVentesJournalieres(dateDebut, dateFin) {
  let allData = []
  let from = 0
  const pageSize = 1000
  while (true) {
    const { data, error } = await supabase
      .from('ventes_journalieres')
      .select('*')
      .gte('date', dateDebut)
      .lte('date', dateFin)
      .order('date')
      .range(from, from + pageSize - 1)
    if (error) throw error
    allData = allData.concat(data)
    if (data.length < pageSize) break
    from += pageSize
  }
  return allData
}

export async function getHistorique(anneeDebut, anneeFin) {
  const { data, error } = await supabase
    .from('ventes_historiques')
    .select('*')
    .gte('annee', anneeDebut)
    .lte('annee', anneeFin)
    .order('annee')
    .order('mois')
  if (error) throw error
  return data
}

export async function getVentesMensuelles(annee) {
  const { data, error } = await supabase
    .from('ventes_mensuelles')
    .select('*')
    .eq('annee', annee)
    .order('mois')
  if (error) throw error
  return data
}

export async function sauvegarderSaisie({ date, concession, neuf, occasion, saisi_par }) {
  const { data, error } = await supabase
    .from('ventes_journalieres')
    .upsert({ date, concession, neuf, occasion, saisi_par, updated_at: new Date().toISOString() },
             { onConflict: 'date,concession' })
    .select()
  if (error) throw error
  return data
}

export async function getSaisieExistante(date, concession) {
  const { data, error } = await supabase
    .from('ventes_journalieres')
    .select('*')
    .eq('date', date)
    .eq('concession', concession)
    .maybeSingle()
  if (error) throw error
  return data
}

export async function getTotauxSemaine(lundiDate, dimancheDate) {
  const { data, error } = await supabase
    .from('ventes_journalieres')
    .select('concession, neuf, occasion')
    .gte('date', lundiDate)
    .lte('date', dimancheDate)
  if (error) throw error

  const totaux = {}
  CONCESSIONS.forEach(c => { totaux[c.id] = { neuf: 0, occasion: 0 } })
  data.forEach(r => {
    if (totaux[r.concession]) {
      totaux[r.concession].neuf += r.neuf
      totaux[r.concession].occasion += r.occasion
    }
  })
  return totaux
}

export async function getTotauxMois(annee, mois) {
  const dateDebut = `${annee}-${String(mois).padStart(2,'0')}-01`
  const lastDay = new Date(annee, mois, 0).getDate()
  const dateFin = `${annee}-${String(mois).padStart(2,'0')}-${lastDay}`
  const { data, error } = await supabase
    .from('ventes_journalieres')
    .select('concession, neuf, occasion')
    .gte('date', dateDebut)
    .lte('date', dateFin)
  if (error) throw error

  const totaux = {}
  CONCESSIONS.forEach(c => { totaux[c.id] = { neuf: 0, occasion: 0 } })
  data.forEach(r => {
    if (totaux[r.concession]) {
      totaux[r.concession].neuf += r.neuf
      totaux[r.concession].occasion += r.occasion
    }
  })
  return totaux
}
// Destinataires du rapport hebdomadaire
export async function getDestinataires() {
  const { data, error } = await supabase
    .from('destinataires_rapport')
    .select('*')
    .order('nom')
  if (error) throw error
  return data
}

export async function ajouterDestinataire({ nom, courriel, role }) {
  const { data, error } = await supabase
    .from('destinataires_rapport')
    .insert({ nom, courriel, role })
    .select()
  if (error) throw error
  return data
}

export async function modifierDestinataire(id, { nom, courriel, role }) {
  const { data, error } = await supabase
    .from('destinataires_rapport')
    .update({ nom, courriel, role })
    .eq('id', id)
    .select()
  if (error) throw error
  return data
}

export async function supprimerDestinataire(id) {
  const { error } = await supabase
    .from('destinataires_rapport')
    .delete()
    .eq('id', id)
  if (error) throw error
}
